import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["valueToCopy", "size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useRef, useState } from 'react';
import { copyToClipboard } from '@sbercloud/ft-copy-to-clipboard';
import { CheckSVG, CopySVG } from '@sbercloud/uikit-product-icons';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { ButtonFunction } from '@snack-uikit/button';
import { jsx as _jsx } from "react/jsx-runtime";
export function CopyButton(_ref) {
  var valueToCopy = _ref.valueToCopy,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'xs' : _ref$size,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsCheckedOpen = _useState2[1];
  var timerId = useRef();
  var openChecked = function openChecked() {
    return setIsCheckedOpen(true);
  };
  var closeChecked = function closeChecked() {
    return setIsCheckedOpen(false);
  };
  var handleClick = function handleClick(event) {
    event.stopPropagation();
    valueToCopy && copyToClipboard(String(valueToCopy));
    openChecked();
    clearTimeout(timerId.current);
    timerId.current = setTimeout(closeChecked, 1000);
  };
  useEffect(function () {
    return function () {
      closeChecked();
      clearTimeout(timerId.current);
    };
  }, []);
  return /*#__PURE__*/_jsx(ButtonFunction, _objectSpread(_objectSpread({}, extractSupportProps(rest)), {}, {
    onClick: handleClick,
    className: className,
    "data-test-id": "button-copy-value",
    type: "button",
    icon: isChecked ? /*#__PURE__*/_jsx(CheckSVG, {}) : /*#__PURE__*/_jsx(CopySVG, {}),
    size: size
  }));
}